// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"b9b903b96ca35ec9","4044":"7cac1f6128c48a02","4515":"b9b903b96ca35ec9","5264":"93105cd6c817aaf2","8378":"265d2fc55d1ab508"}[chunkId] + ".css";
};